// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__1MoaU","alert":"SettungsInbox_alert__2NFcR"};